import { Dispatch, SetStateAction } from 'react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';

export const IncomingCallBarTrail = ({
  numOfIncomingCalls,
  setPosition,
  disabledLeftArrow,
  disabledRightArrow,
  count,
  showTrailingIcon,
  onHandleTrailIcon,
}: {
  numOfIncomingCalls: number;
  setPosition: Dispatch<SetStateAction<number>>;
  disabledLeftArrow: boolean;
  disabledRightArrow: boolean;
  count: string;
  showTrailingIcon: boolean;
  onHandleTrailIcon: () => void;
}) => {
  if (numOfIncomingCalls === 0 && !showTrailingIcon) return;

  const trailIcon = showTrailingIcon ? (
    <NakedButton onClick={onHandleTrailIcon}>
      <Icon color='white' name='collapse-left-small' />
    </NakedButton>
  ) : null;

  return (
    <div css={{ gridArea: 'trail' }} className='trail'>
      {numOfIncomingCalls > 1 && (
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(0.5) }}>
          <NakedButton disabled={disabledLeftArrow} onClick={() => setPosition((prev) => prev - 1)}>
            <Icon color={disabledLeftArrow ? 'disabled' : 'white'} name='caret-left-small' />
          </NakedButton>
          <Text color='white' css={{ flex: 1 }}>
            {count}
          </Text>
          <NakedButton disabled={disabledRightArrow} onClick={() => setPosition((prev) => prev + 1)}>
            <Icon color={disabledRightArrow ? 'disabled' : 'white'} name='caret-right-small' />
          </NakedButton>
        </div>
      )}
      {trailIcon}
    </div>
  );
};
